import LoyalityApis from '@/Components/Controllers/LoyalityApis';
import store from '@/store/store';
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    obj: {},
  },
  getters: {
    subscribed: (state) => {
      if(_.isEmpty(state.obj)){
        return false;
      }
      return true;
    },
    obj: state => state.obj,
    badges: (state) => {
      if(_.isEmpty(state.obj)){
        return [];
      } 
      // append is_expired key
      moment.tz.setDefault('America/Toronto');
      let todayDate = moment();
      let result = state.obj.user_badges.filter( item => {
        // do not return badges having no dates
        // if( item.badge && item.badge.end_date){
          let endingDate =  item.badge && item.badge.end_date ? moment(item.badge.end_date) : null; 
          if(endingDate) {
            let daysLeft = endingDate.diff(todayDate, 'days');
           // // here diff gives the gap so we need to always add 1 day to reach the last date so, 
            //daysLeft = daysLeft + 1;
            item.is_expired = daysLeft < 0 ? true : false;
            item.expired_within = daysLeft;
          } else {
            item.is_expired = false;
            item.expired_within = null;
          }
          return item;
        // }
      });
      return result;
    },

    earnedBadges: (state) => {
      if(_.isEmpty(state.obj)){
        return [];
      } 
      if(state.obj.user_badges && state.obj.user_badges.length > 0) {


        return state.obj.user_badges.filter(item =>  {
          if(item.badge_earned || (item.no_of_times_earned > 0 && item.badge && item.badge.no_of_times_repeatable > 1) ) {
            return item;
          }
        })
        // return _.filter(state.obj.user_badges, 
        //     {  'badge_earned': true , 'no_of_times_earned': true }
        // )
      }
      return [];
    },

    notEarnedBadges: (state) => {
      if(_.isEmpty(state.obj)){
        return [];
      } 
      
      if(state.obj.user_badges && state.obj.user_badges.length > 0) {
        moment.tz.setDefault('America/Toronto');
        let todayDate = moment();
        let result = state.obj.user_badges.filter( item => {
          if(item.badge_earned == false) {
            return item;
            // let endingDate =  item.badge && item.badge.end_date ? moment(item.badge.end_date) : null; 
            // if(endingDate) {
            //   let daysLeft = endingDate.diff(todayDate, 'days');
            //  // item.is_expired = daysLeft < 0 ? true : false; comes from api now
            //   item.expired_within = daysLeft;
            // } else {
            //   // item.is_expired = false; // comes from api now
            //   item.expired_within = null;
            // }
            
          }
        });
        return result;
      }
      return [];
    },

    // earnedBadges: (state) => {
    //   if(_.isEmpty(state.obj)){
    //     return [];
    //   } 
    //   if(state.obj.user_badges && state.obj.user_badges.length > 0) {
    //     return _.filter(state.obj.user_badges, 
    //         {  'badge_earned': true }
    //     )
    //   }
    //   return [];
    // },
  },

  mutations: {
  
    objMutate(state, data) {
      state.obj = data;
    },
  },
  actions: {
 
    async setUserLoyalityObj(context, data) {
      // First of all business must have loyality enabled and must have business id and user id
      if(store.getters['businessprofile/businessLoyality'].is_active && data.user_id && data.business_id){
        let res = await LoyalityApis.getUserLoyality(data.user_id, data.business_id);
        if(res.status == 200){
          context.commit('objMutate', res.data.payload);
        } else {
          context.commit('objMutate', {});
        }
        return res;
      } else {
        context.commit('objMutate', {});
      }
     
    },

    async joinUserOnLoyalityProgram(context, data) {
      // to get subscribe to the program business must have active loyality 
      if(store.getters['businessprofile/businessLoyality'].is_active && data.user_id && data.business_id){
        let res = await LoyalityApis.registerToLoyality(data.user_id, data.business_id, (data.referral_key ? data.referral_key : '') );
        if(res.status == 201){
          context.commit('objMutate', res.data.payload);
        } else {
         // context.commit('objMutate', {});
        }
        return res;
      } else {
        return false;
      }
    },
  },
};
